import React, { ReactElement } from 'react';
import { Image, Text, VideoPlayer } from '@shootsta/common-react';

import './styles/_testimonial.scss';

interface TestimonialProps {
  logoUrl: string;
  text: string;
  thumbnailUrl?: string;
  videoUrl?: string;
  joinDate: string;
  brandingColor: string;
}

const Testimonial = ({
  logoUrl,
  text,
  thumbnailUrl,
  videoUrl,
  joinDate,
  brandingColor
}: TestimonialProps): ReactElement => (
  <div className="testimonial">
    <div className="testimonial__inner">
      <div className="testimonial__player-wrapper">
        <VideoPlayer {...{ videoUrl, thumbnailUrl, brandingColor }} />
      </div>
      <div className="testimonial__content">
        <Image imageUrl={logoUrl} height="100px" />
        <Text className="testimonial__content__quote" body>
          {`"${text}"`}
        </Text>
        {joinDate ? (
          <Text prefixIcon="bookings" prefixSize={24} heading5 className="testimonial__content__joined">
            {`Joined on ${joinDate}`}
          </Text>
        ) : null}
      </div>
    </div>
  </div>
);

export default Testimonial;
